export interface UserFieldApiCategory {
    _id: string;
    name: string;
    categories?: UserFieldApiCategory[];
}


export interface UserFieldApiResponse {
    _id: string;
    _rev: string;
    name: string;
    fieldType: string;
    order: number;
    isRequired: boolean;
    isFeatured: boolean;
    isUnique: boolean;
    visibleBy: string[];
    description: string;
    organisation: string;
    modifiedDate: string;
    systemModifiedDate: string;

    categories?: UserFieldApiCategory[];
}

export type UserFieldCategory = {
    _id: string;
    name: string;
    categories?: UserFieldCategory[];
};


export class UserField {
    id: string;
    rev: string;
    name: string;
    fieldType: string;

    order: number;
    isRequired: boolean;
    isFeatured: boolean;
    isUnique: boolean;
    visibleBy: string[];

    description: string;
    organisation: string;
    modifiedDate: string;
    systemModifiedDate: string;

    categories?: UserFieldCategory[];

    constructor(data: Partial<UserField> = {}) {
        Object.assign(this, data);
    }

    static fromApiResponse(response: UserFieldApiResponse): UserField {
        return new UserField({
            id: response._id,
            rev: response._rev,
            name: response.name,
            fieldType: response.fieldType,
            order: response.order,
            isRequired: response.isRequired,
            isFeatured: response.isFeatured,
            isUnique: response.isUnique,
            visibleBy: response.visibleBy,
            description: response.description,
            organisation: response.organisation,
            modifiedDate: response.modifiedDate,
            systemModifiedDate: response.systemModifiedDate,
            categories: response.categories
        });
    }
}